import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modalpopup',
  templateUrl: './modalpopup.component.html',
  styleUrls: ['./modalpopup.component.scss']
})
export class ModalpopupComponent {

  [key: string]: any;
  //public dialogOpened = false;
  public windowOpened = false;
  @ViewChild('popupModal') public modal?: ElementRef;
  @Input() public dialogOpened: boolean = false;
  @Output() public dialogOpenedChange = new EventEmitter();;
  @Input() public message: string = '';
  @Input() public header: string = '';
  @Input() public actionYesLabel: string = '';
  @Input() public actionNoLabel: string = '';
  @Input() public isInfo = false;
  @Output() public submitted = new EventEmitter();
  @Output() public cancelled = new EventEmitter();

  public close(component: string) {
    this.cancelled.emit();
    this[`${component}Opened`] = false;
    this.dialogOpened = false;
  }

  public open(component: string) {
    this[`${component}Opened`] = true;
    this.dialogOpened = true;
  }

  public action(status: string) {
    this.dialogOpened = false;
  }

  public emitSubmit(state: string): void {
    this.submitted.emit();
    this.dialogOpened = false;
  }

  public emitCancel(state: string): void {
    this.cancelled.emit();
    this.dialogOpened = false;
  }
}
